import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'information-dialog',
    templateUrl: './information-dialog.component.html',
    // Same dialog chrome as the confirm dialog, which is where it used to come from too: both templates
    // leaned on mat-dialog-content/-actions for their padding.
    styleUrls: ['../../confirm-dialog/confirm-dialog.component.scss'],
    standalone: false
})
export class InformationDialogComponent {
  message: string;

  constructor(private readonly activeModal: NgbActiveModal) {}

  close(): void {
    this.activeModal.close(true);
  }
}
